import { scrollStyle } from '@themes/mixins';
import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  gap: 22px;
  ${scrollStyle()}
  min-height:100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;
export const ContentWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
export const LeftSideBarContainer = styled.div<{ $isOpen: boolean }>`
  width: ${({ $isOpen }) => ($isOpen ? '300px' : '65px')};
  transition: width 0.2s ease;
`;
export const NavBarContainer = styled.div`
  position: sticky;
  width: 100%;
  z-index: 99;
  top: 0;
`;
export const NavBarWrapper = styled.div``;
export const MainContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;
